import Vue from "vue";
import { Component } from "vue-property-decorator";
import { AbsenceSalarieDto } from "../../../../dto/GenApi.iNotPaie.Dto/AbsenceSalarieDto";
import { ServicesFactoryInstance } from "../../../Controls/ServicesFactory";
import $ from "jquery";
import { NotificationServiceInstance } from "../../../../shared/services/notification.service";
import { EtatAbsencesEnum } from "../../../../dto/GenApi.iNotPaie.Dto/EtatAbsencesEnum";
import { ActionAbsencesEnum } from "../../../../dto/GenApi.iNotPaie.Dto/ActionAbsencesEnum";
import { CommandeChangementEtatAbsenceDto } from "../../../../dto/GenApi.iNotPaie.Dto/CommandeChangementEtatAbsenceDto";
import { ParametresInstance } from "../../../Controls/Parameters";

@Component
export default class modalChangerEtatAbsence extends Vue {
	public absence?: AbsenceSalarieDto = undefined;
	public action: ActionAbsencesEnum = ActionAbsencesEnum.ValiderAbsenceParGestionnaire;
	public isLoading = false;
	public libelleEtat = ""
	public libelleAction = ""
	public estCommentaireObligatoire = false;

	public init(absence: AbsenceSalarieDto, action: ActionAbsencesEnum): void {
    	this.absence = absence;
    	this.action = action;
    	this.libelleEtat = ParametresInstance.getLibelleEtatAbsence(this.absence.Etat);
    	this.libelleAction = ParametresInstance.getLibelleActionAbsence(action);
    	this.estCommentaireObligatoire = this.getEstCommentaireObligatoire(action);
    	this.absence.CommentaireManager = "";
    	this.$forceUpdate();
	}

	public save(): void {
    	if (!this.ControleAction()) {
			return;
		}

        const commande: CommandeChangementEtatAbsenceDto = { IdAbsence: this.absence?.Id ?? 0, Action: this.action, Commentaire: this?.absence?.CommentaireManager, Etat: this.absence!.Etat};

    	this.isLoading = true;
    	ServicesFactoryInstance.AbsencesService.changerEtatAbsence(commande, true, datas => {
            this.isLoading = false;

            // Affiche la notification de succès
            this.sendNotificationSuccess(datas[0].Etat);

    		this.$emit("changerEtatAbsenceOk");
    		$("#modalChangerEtatAbsence").modal("hide");
    	}, () => {
    		this.isLoading = false;
    	});

    	this.$forceUpdate();
	}

	public ControleAction(): boolean {
    	if (this.absence == undefined) {
    		NotificationServiceInstance.SendWarning("L'absence est vide");

    		return false;
    	}
    	if (this.action == ActionAbsencesEnum.ValiderAbsenceParGestionnaire) {
    		if (this.absence.Etat != EtatAbsencesEnum.EnAttenteValidationGestionnaire &&
                this.absence.Etat != EtatAbsencesEnum.EnAttenteValidationResponsableNiveau_1 &&
                this.absence.Etat != EtatAbsencesEnum.EnAttenteValidationResponsableNiveau_2
    		) {
				NotificationServiceInstance.SendWarning(`L'absence ne peut pas être validée car elle est ${this.libelleEtat}`);
			}

    		return false;
    	}
    	if (this.action == ActionAbsencesEnum.ValiderAbsenceParResponsableNiveau_1 && this.absence.Etat != EtatAbsencesEnum.EnAttenteValidationResponsableNiveau_1) {
    		NotificationServiceInstance.SendWarning(`L'absence ne peut pas être validée par un responsable niveau 1 car elle est ${this.libelleEtat}`);

    		return false;
    	}
    	if (this.action == ActionAbsencesEnum.ValiderAbsenceParResponsableNiveau_2 && this.absence.Etat != EtatAbsencesEnum.EnAttenteValidationResponsableNiveau_2) {
    		NotificationServiceInstance.SendWarning(`L'absence ne peut pas être validée par un responsable niveau 2 car elle est ${this.libelleEtat}`);

    		return false;
    	}
    	if (this.action == ActionAbsencesEnum.DemanderAnnulerAbsenceParSalarie &&
            this.absence.Etat != EtatAbsencesEnum.EnAttenteValidationGestionnaire &&
            this.absence.Etat != EtatAbsencesEnum.EnAttenteValidationResponsableNiveau_1 &&
            this.absence.Etat != EtatAbsencesEnum.EnAttenteValidationResponsableNiveau_2 &&
            this.absence.Etat != EtatAbsencesEnum.Valide) {
    		NotificationServiceInstance.SendWarning(`L'absence ne peut pas être annulée car elle est ${this.libelleEtat}`);

    		return false;
    	}
    	if (this.action == ActionAbsencesEnum.AnnulerAbsenceParGestionnaire &&
            this.absence.Etat != EtatAbsencesEnum.EnAttenteValidationGestionnaire &&
            this.absence.Etat != EtatAbsencesEnum.EnAttenteValidationResponsableNiveau_1 &&
            this.absence.Etat != EtatAbsencesEnum.EnAttenteValidationResponsableNiveau_2 &&
            this.absence.Etat != EtatAbsencesEnum.Valide &&
            this.absence.Etat != EtatAbsencesEnum.EnAttenteAnnulationGestionnaire &&
            this.absence.Etat != EtatAbsencesEnum.EnAttenteAnnulationResponsableNiveau_1 &&
            this.absence.Etat != EtatAbsencesEnum.EnAttenteAnnulationResponsableNiveau_2) {
    		NotificationServiceInstance.SendWarning(`L'absence ne peut pas être annulée car elle est ${this.libelleEtat}`);

    		return false;
    	}
    	if (this.action == ActionAbsencesEnum.AnnulerAbsenceParResponsableNiveau_1 && this.absence.Etat != EtatAbsencesEnum.EnAttenteAnnulationResponsableNiveau_1) {
    		NotificationServiceInstance.SendWarning(`L'absence ne peut pas être annulée par un responsable niveau 1 car elle est ${this.libelleEtat}`);

    		return false;
    	}
    	if (this.action == ActionAbsencesEnum.AnnulerAbsenceParResponsableNiveau_2 && this.absence.Etat != EtatAbsencesEnum.EnAttenteAnnulationResponsableNiveau_2) {
    		NotificationServiceInstance.SendWarning(`L'absence ne peut pas être annulée par un responsable niveau 2 car elle est ${this.libelleEtat}`);

    		return false;
    	}
    	if (this.action == ActionAbsencesEnum.RefuserAbsenceParGestionnaire &&
            this.absence.Etat != EtatAbsencesEnum.EnAttenteValidationGestionnaire &&
            this.absence.Etat != EtatAbsencesEnum.EnAttenteValidationResponsableNiveau_1 &&
            this.absence.Etat != EtatAbsencesEnum.EnAttenteValidationResponsableNiveau_2) {
    		NotificationServiceInstance.SendWarning(`L'absence ne peut pas être refusée car elle est ${this.libelleEtat}`);

    		return false;
    	}
    	if (this.action == ActionAbsencesEnum.RefuserAbsenceParResponsable &&
            this.absence.Etat != EtatAbsencesEnum.EnAttenteValidationResponsableNiveau_1 &&
            this.absence.Etat != EtatAbsencesEnum.EnAttenteValidationResponsableNiveau_2) {
    		NotificationServiceInstance.SendWarning(`L'absence ne peut pas être refusée car elle est ${this.libelleEtat}`);

    		return false;
    	}
    	if (this.action == ActionAbsencesEnum.AnnulerDemandeAnnulationAbsenceParGestionnaire &&
            this.absence.Etat != EtatAbsencesEnum.EnAttenteAnnulationGestionnaire &&
            this.absence.Etat != EtatAbsencesEnum.EnAttenteAnnulationResponsableNiveau_1 &&
            this.absence.Etat != EtatAbsencesEnum.EnAttenteAnnulationResponsableNiveau_2) {
    		NotificationServiceInstance.SendWarning(`La demande d'annulation ne peut pas être annulée car la demande est ${this.libelleEtat}`);

    		return false;
    	}
    	if (this.action == ActionAbsencesEnum.RefuserAnnulationAbsenceParResponsable &&
            this.absence.Etat != EtatAbsencesEnum.EnAttenteAnnulationResponsableNiveau_1 &&
            this.absence.Etat != EtatAbsencesEnum.EnAttenteAnnulationResponsableNiveau_2) {
    		NotificationServiceInstance.SendWarning(`La demande d'annulation d'absence ne peut pas être refusée car la demande est ${this.libelleEtat}`);

    		return false;
    	}

    	if ((this.action == ActionAbsencesEnum.RefuserAbsenceParGestionnaire || this.action == ActionAbsencesEnum.RefuserAbsenceParResponsable) &&
            (this.absence.CommentaireManager == undefined || this.absence.CommentaireManager.trim() == "")) {
    		NotificationServiceInstance.SendWarning("Vous devez saisir un commentaire pour effectuer un refus d'absence");
    	}

    	if ((this.action == ActionAbsencesEnum.AnnulerDemandeAnnulationAbsenceParSalarie) &&
            this.absence.Etat != EtatAbsencesEnum.EnAttenteAnnulationResponsableNiveau_1 && this.absence.Etat != EtatAbsencesEnum.EnAttenteAnnulationResponsableNiveau_2) {
    		NotificationServiceInstance.SendWarning(`La demande d'annulation ne peut pas être annulée car  la demande est ${this.libelleEtat}`);
    	}

    	return true;
	}

	public cancel(): void {
    	$("#modalChangerEtatAbsence").modal("hide");
	}

	public ucFirst(text: string): string {
    	return text.charAt(0).toUpperCase() + text.slice(1);
	}

	public getEstCommentaireObligatoire(action: ActionAbsencesEnum): boolean {
    	let estCommentaireObligatoire = false;

    	if (action == ActionAbsencesEnum.RefuserAbsenceParGestionnaire ||
            action == ActionAbsencesEnum.RefuserAbsenceParResponsable ||
            action == ActionAbsencesEnum.RefuserAnnulationAbsenceParResponsable) {
    		estCommentaireObligatoire = true;
    	}

    	return estCommentaireObligatoire;
    }

    //Permet d'afficher la notification de succès
    private sendNotificationSuccess(newEtatAbsence: EtatAbsencesEnum): void {
        let libelle: string = "";
        
        if (this.action === ActionAbsencesEnum.ValiderAbsenceParResponsableNiveau_1 ||
            this.action === ActionAbsencesEnum.ValiderAbsenceParResponsableNiveau_2) {
            //Cas non salarié - Validation d'absence
            libelle = "La validation d'absence a été enregistrée.";

        } else if (this.action === ActionAbsencesEnum.RefuserAbsenceParResponsable) {
            //Cas non salarié - Refus d'absence
            libelle = "Le refus d'absence a été enregistré.";

        } else if (this.action === ActionAbsencesEnum.AnnulerAbsenceParResponsableNiveau_1 ||
            this.action === ActionAbsencesEnum.AnnulerAbsenceParResponsableNiveau_2) {
            //Cas non salarié - Validation d'annulation d'absence
            libelle = "La validation d'annulation d'absence a été enregistrée.";

        } else if (this.action === ActionAbsencesEnum.RefuserAnnulationAbsenceParResponsable) {
            //Cas non salarié - Refus d'annulation d'absence
            libelle = "Le refus d'annulation d'absence a été enregistré.";

        } else if (this.action === ActionAbsencesEnum.DemanderAnnulerAbsenceParSalarie) {
            //Cas salarié - Annulation d'absence
            if (newEtatAbsence === EtatAbsencesEnum.Annule) {
                libelle = "L'annulation d'absence a été enregistrée.";
            } else {
                libelle = "La demande d'annulation d'absence a été enregistrée.";
            }
            
        } else if (this.action === ActionAbsencesEnum.AnnulerDemandeAnnulationAbsenceParSalarie) {
            // Cas salarié - Annulation de la demande d'annulation d'absence
            libelle = "L'annulation de la demande d'annulation d'absence a été enregistrée.";
        } else {
            // Cas normalement impossible - Libellé générique
            libelle = "L'absence a été modifiée.";

        }
        
        NotificationServiceInstance.SendSuccess(libelle);
    }
}



// WEBPACK FOOTER //
// ./src/components/gestionDesAbsences/modals/modalChangerEtatAbsence/modalChangerEtatAbsence.ts